import { styled } from '@mui/material/styles';
import { ReactComponent as Icon } from '@/assets/close.svg';
import classNames from 'classnames';

export const CloseIcon = styled(
	({ className }: { className?: string }) => (
		<Icon className={classNames('icon', 'close', className)} />
	),
	{
		target: 'CloseIcon-root',
		label: 'CloseIcon',
	},
)({});
